var map = {
	"./site-logo-desktop-footer.svg": 30269,
	"./site-logo-drawer-mobile.svg": 59269,
	"./site-logo-drawer.svg": 90694,
	"./site-logo-external.svg": 22080,
	"./site-logo-tv.svg": 37139,
	"./site-logo-wrapper-mobile-scrolled.svg": 12578,
	"./site-logo-wrapper-mobile.svg": 36717,
	"./site-logo-wrapper-scrolled.svg": 58095,
	"./site-logo-wrapper.svg": 2894
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72906;